import { Chip } from "@mui/material";
import React from "react";
import { AbsenceRequestStatus } from "../../constants/absenceEnums";

interface AbsenceStatusChipProps {
  status: AbsenceRequestStatus;
  size?: "small" | "medium";
}

interface StatusConfig {
  label: string;
  color: string;
  textColor: string;
}

const STATUS_CONFIG: Partial<Record<AbsenceRequestStatus, StatusConfig>> = {
  [AbsenceRequestStatus.Pending]: {
    label: "Pending",
    color: "#FFC107", // Yellow
    textColor: "#000",
  },
  [AbsenceRequestStatus.Approved]: {
    label: "Approved",
    color: "#4CAF50", // Green
    textColor: "#fff",
  },
  [AbsenceRequestStatus.Denied]: {
    label: "Denied",
    color: "#F44336", // Red
    textColor: "#fff",
  },
  [AbsenceRequestStatus.Cancelled]: {
    label: "Cancelled",
    color: "#9E9E9E", // Gray
    textColor: "#fff",
  },
  [AbsenceRequestStatus.Revoked]: {
    label: "Revoked",
    color: "#FF5722", // Deep Orange
    textColor: "#fff",
  },
};

export const AbsenceStatusChip: React.FC<AbsenceStatusChipProps> = ({
  status,
  size = "small",
}) => {
  const config = STATUS_CONFIG[status];

  if (!config) {
    return null;
  }

  return (
    <Chip
      label={config.label}
      size={size}
      style={{
        backgroundColor: config.color,
        color: config.textColor,
        fontWeight: 600,
      }}
      sx={{
        "& .MuiChip-label": {
          px: size === "small" ? 1 : 1.5,
          color: config.textColor,
        },
        "& .MuiChip-root": {
          backgroundColor: config.color,
        },
      }}
    />
  );
};







